<template>
    <el-select v-model="model"
        size="small"
        :clearable="true"
        placeholder="组件分组">
        <el-option v-for="item in list"
            :key="item"
            :label="item"
            :value="item">
        </el-option>
    </el-select>
</template>

<script>
export default {
    name: 'groupSelect',
    props: {
        value: String,
        list: {
            type: Array,
            default: () => []
        },
        update: Function
    },
    data() {
        return {

        }
    },
    computed: {
        model: {
            get() {
                return this.value
            },
            set(val) {
                this.update(val)
            }
        }
    }
}
</script>
